<template>
  <div class="card mb-2">
    <div class="card-header bg-primary text-white d-flex">
      <a v-b-toggle="`collapse-open-reviews-card`" class="collapse-icon c-pointer">
        <font-awesome-icon class="when-opened" icon='caret-down' size="lg" />
        <font-awesome-icon class="when-closed fa-w-10" icon='caret-right' size="lg" />
      </a>
      <span class="font-weight-bold">Open Reviews</span>
    </div>
    <b-collapse
      :id="'collapse-open-reviews-card'"
      v-model="showCollapse"
    >
      <div class="card-body">
        <div v-if="!entities || entities.length === 0">
          No Open Reviews exist currently on this Project
        </div>
        <div v-else>
          <div id='visible-open-reviews'
            v-for='openReview in visibleEntities'
            :key='openReview.id'>
            <div class="card mb-2">
              <div class="card-body">
                <div class="row mb-2">
                  <div class="col-sm-3">
                    <div class="list-header">
                      Assigned To
                    </div>
                    <div class="list-details">
                      {{ openReview.assigneeName || 'None' }}
                    </div>
                  </div>
                  <div class="col-sm-3">
                    <div class="list-header">
                      Assigned By
                    </div>
                    <div class="list-details">
                      {{ openReview.assignerName || 'None' }}
                    </div>
                  </div>
                  <div class="col-sm-2">
                    <div class="list-header">
                      Open Date
                    </div>
                    <div class="list-details">
                      {{ openReview.openDate | dateString }}
                    </div>
                  </div>
                  <div class="col-sm-3">
                    <div class="list-header">
                      Component
                    </div>
                    <div class="list-details">
                      {{ getComponentName(openReview) }}
                    </div>
                  </div>
                  <div class="col-sm-1">
                    <router-link v-if="openReview.serviceId"
                      :to="{ name: 'projectService', params: {
                      project_id: $route.params.project_id,
                      id: openReview.serviceId }}"
                      class="btn btn-secondary btn-sm">
                      View
                    </router-link>
                    <router-link v-if="openReview.instrumentId"
                      :to="{ name: 'projectInstrument', params: {
                      project_id: $route.params.project_id,
                      id: openReview.instrumentId }}"
                      class="btn btn-secondary btn-sm">
                      View
                    </router-link>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <PaginationControls
           :orderedEntities="orderedEntities"
           :initialPageSize="initialPageSize"
           :pageSize="pageSize"
           :pageSizeOptions="pageSizeOptions"
           :currentPage="currentPage"
           :firstVisibleEntry="firstVisibleEntry"
           :lastVisibleEntry="lastVisibleEntry"
           :rows="rows"
           @update-current-page="updateCurrentPage"
           @update-page-size="updatePageSize">
          </PaginationControls>
        </div>
      </div>
    </b-collapse>
  </div>
</template>

<script>
import { mapState } from 'vuex';
import { EntityModules } from '@/store/moduleConfig';
import CollapseControl from '@/mixins/CollapseControl';
import Pagination from '@/mixins/Pagination';
import PaginationControls from '../common/PaginationControls.vue';

export default {
  name: 'OpenReviewsCard',
  components: {
    PaginationControls,
  },
  mixins: [CollapseControl, Pagination],
  mounted() {
    this.$store.dispatch(`${EntityModules.OPEN_REVIEWS.namespace}/fetchEntities`, {
      parentType: EntityModules.OPEN_REVIEWS.parentType,
      parentId: parseInt(this.$route.params.project_id, 10),
      entityType: EntityModules.OPEN_REVIEWS.entityType,
      forceLoad: true,
    });
  },
  data() {
    return {
      showCollapse: false,
    };
  },
  computed: {
    ...mapState(EntityModules.OPEN_REVIEWS.namespace, {
      entities: state => state.entities,
      loading: state => state.loading,
    }),
  },
  methods: {
    entitySort(a, b) {
      return a.id - b.id;
    },
    getComponentName(review) {
      let componentName = 'None';
      if (review && review.serviceId) {
        componentName = 'Service';
      } else if (review && review.instrumentId) {
        componentName = 'Instrument';
      }
      return componentName;
    },
  },
};
</script>
